import styled, { keyframes } from 'styled-components';

import { colors } from '../../healtheraComponents';

const spinning = keyframes`
  0% { transform: rotate(0); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  margin: 30px auto;
  position: relative;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background-color: ${colors.HEALTHERA_GREEN};

  animation: ${spinning} 1.5s ease both infinite;

  &::after {
    content: '';
    position: absolute;
    left: 10%;
    top: 10%;
    width: 80%;
    height: 80%;
    background-color: white;
    border-radius: 50%;
  }

  &::before {
    content: '';
    position: absolute;
    width: 8%;
    height: 8%;
    background-color: white;
    border-radius: 50%;
    left: calc(46%);
    top: 1%;
  }
`;

export default Spinner;
